var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpLong = function SvgArrowUpLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 77,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303742",
    d: "M29.058 8.98c-2.71 5.047-5.205 9.76-7.778 14.443-.215.334-.79.45-1.79.985.574-2.445.877-4.41 1.49-6.259 1.666-4.86 3.46-9.589 5.28-14.39.222-.583.365-1.194.74-1.717C28.105.297 29.668.14 31.06 1.834q.988 1.249 1.66 2.626c1.691 3.472 3.278 6.986 4.865 10.5.299.613.282 1.356.493 2.434-4-1.35-3.676-5.472-6.467-7.445-.094.713-.237 1.324-.275 1.892-1.726 21.815-9.768 41.15-22.733 58.536-1.314 1.831-2.91 3.473-4.428 5.144-.773.872-1.955 1.422-3.05.341-1.122-1.008-.735-2.026.248-2.985C12.5 62.2 18.439 48.642 23.505 34.586c2.682-7.305 4.536-14.757 5.433-22.489.1-.961.12-1.951.12-3.117"
  })));
};
export default SvgArrowUpLong;